/** @format */
import { ChangeDetectionStrategy, Component, Inject, inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FudisDialogService } from '@funidata/ngx-fudis';
import { LocalizedString } from 'common-typescript/types';
import { LocaleService } from 'sis-common';

export interface AccessDeniedModalFdValues {
    expectedPermissions: LocalizedString[];
}

export function accessDeniedModalFdOpener() {
    const fudisDialogService = inject(FudisDialogService);
    return (values: AccessDeniedModalFdValues) => fudisDialogService.open(AccessDeniedModalFdComponent, { data: values });
}

@Component({
    selector: 'sis-access-denied-modal-fd',
    templateUrl: './access-denied-modal-fd.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class AccessDeniedModalFdComponent {
    localizedNames: string[] = [];

    constructor(
        localeService: LocaleService,
        @Inject(MAT_DIALOG_DATA) protected values: AccessDeniedModalFdValues,
    ) {
        this.localizedNames = (values?.expectedPermissions ?? [])
            .map(permissionName => localeService.localize(permissionName))
            .filter(Boolean)
            .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
    }
}
